import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";
import type { PROSPECT_ERROR_CODES } from "@amtana/prospect-contract";

// What a user reads when a prospect fails to load or change (packages/module ADR-001).

const EN = {
  notFoundTitle: "This prospect doesn't exist",
  notFoundDescription: "It may have been deleted. Open your prospects to pick another.",
} as const;

const ES: Translation<typeof EN> = {
  notFoundTitle: "Este prospecto no existe",
  notFoundDescription: "Puede que se haya eliminado. Abre tus prospectos para elegir otro.",
};

export const PROSPECT_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const PROSPECT_ERROR_COPY = {
  prospect_not_found: {
    title: phrase(PROSPECT_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(PROSPECT_ERROR_CATALOGS, "notFoundDescription"),
  },
} satisfies ErrorCopyFor<typeof PROSPECT_ERROR_CODES>;
